<template>
  <div>
    <br />
    <v-row>
      <v-col cols="12" sm="4" md="2">
        <v-card
          :class="
            flow.value <= 10
              ? 'primary darken-1 ten'
              : flow.value >= 11 && flow.value <= 69
              ? 'primary darken-1 forty'
              : 'primary darken-1 seventy'
          "
        >
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small" v-if="flow"
                >Atualizado em {{ flow.date }}</span
              >
              <span style="color: lightgrey; font-size: small" v-else
                >Atualizado em ##/##/####</span
              >
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2"> mdi-waves </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text"
            >Vazão</v-card-subtitle
          >
          <v-card-text>
            <v-row v-if="!flow">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer />
              <v-col cols="9">
                <span style="color: orange"
                  >Os dados de vazão estão indisponíveis no momento.</span
                >
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col
                cols="12"
                sm="12"
                md="12"
                class="align-center justify-center"
              >
                <strong class="display-1 font-weight-bold" v-if="flow.value">
                  {{ flow.value.toFixed(3) }}
                </strong>
                <strong>m³/s</strong>
                <div v-if="flow.trend === 'equal'">
                  <v-icon style="color: lightgrey" left>mdi-equal</v-icon
                  ><span style="color: lightgrey">Estável</span>
                </div>
                <div v-else-if="flow.trend === 'up'">
                  <v-icon style="color: lightgrey" left>mdi-menu-up</v-icon
                  ><span style="color: lightgrey">Subindo</span>
                </div>
                <div v-else-if="flow.trend === 'down'">
                  <v-icon style="color: lightgrey" left>mdi-menu-down</v-icon
                  ><span style="color: lightgrey">Descendo</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-card
          :class="
            availability.q30 <= 5
              ? 'primary darken-1 cheia'
              : availability.q30 >= 6 && availability.q30 <= 24
              ? 'primary darken-1 rioalto'
              : availability.q30 >= 25 && availability.q30 <= 74
              ? 'primary darken-1 normal'
              : availability.q30 >= 75 && availability.q30 <= 94
              ? 'primary darken-1 riobaixo'
              : availability.q30 >= 95
              ? 'primary darken-1 estiagem'
              : 'primary darken-1 none'
          "
        >
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span
                style="color: lightgrey; font-size: small"
                v-if="availability"
                >Atualizado em {{ availability.date }}</span
              >
              <span style="color: lightgrey; font-size: small" v-else
                >Atualizado em ##/##/####</span
              >
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2"> mdi-chart-bubble </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text"
            >Disponibilidade hídrica</v-card-subtitle
          >
          <v-card-text>
            <v-row v-if="!availability">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer />
              <v-col cols="9">
                <span style="color: orange"
                  >Os dados de disponibilidade hídrica estão indisponíveis no
                  momento.</span
                >
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12" v-show="availability">
                <WaterAvailabilityChart
                  :availability="availability"
                  class="mt-n6"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-card
          class="primary darken-1"
          :style="`border-left: 7px solid ${waterQualityBorderColor} !important`"
        >
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span
                style="color: lightgrey; font-size: small"
                v-if="quality.year"
                >Atualizado em {{ quality.year }}</span
              >
              <span style="color: lightgrey; font-size: small" v-else
                >Atualizado em ##/##/####</span
              >
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2"> mdi-beer-outline </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text"
            >Qualidade da água</v-card-subtitle
          >
          <v-card-text>
            <v-row v-if="quality.values" class="white--text">
              <v-col class="pa-3" cols="12">
                <WaterQualityChart :quality="quality" class="mt-n6" />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer />
              <v-col cols="9">
                <span style="color: orange"
                  >Os dados de qualidade da água estão indisponíveis no
                  momento.</span
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-card class="primary darken-1">
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small" v-if="date"
                >Atualizado em {{ date }}</span
              >
              <span style="color: lightgrey; font-size: small" v-else
                >Atualizado em ##/##/####</span
              >
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-weather-pouring
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text"
            >Chuva</v-card-subtitle
          >
          <v-card-text>
            <v-row v-if="!values">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer />
              <v-col cols="9">
                <span style="color: orange"
                  >Os dados de chuva estão indisponíveis no momento.</span
                >
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  {{ values.precIntensity.toFixed(1) }}
                  <span class="font-weight-thin title">mm</span>
                </strong>
              </v-col>
              <v-col cols="12">
                <span>Probabilidade para chuva</span>
                <br />
                <strong class="title font-weight-bold"
                  >{{ values.precProbability * 100 }}
                  <span class="font-weight-thin title">%</span></strong
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-card class="primary darken-1">
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small" v-if="date"
                >Atualizado em {{ date }}</span
              >
              <span style="color: lightgrey; font-size: small" v-else
                >Atualizado em ##/##/####</span
              >
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-water-alert-outline
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text"
            >Umidade</v-card-subtitle
          >
          <v-card-text>
            <v-row v-if="!values">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer />
              <v-col cols="9">
                <span style="color: orange"
                  >Os dados de umidade estão indisponíveis no momento.</span
                >
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <v-icon>mdi-arrow-down</v-icon>
                  {{ Math.trunc(values.minHumidity) }}
                  <span class="font-weight-thin title">%</span>
                </strong>
              </v-col>
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <v-icon>mdi-arrow-up</v-icon>
                  {{ Math.trunc(values.maxHumidity) }}
                  <span class="font-weight-thin title">%</span>
                </strong>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-card class="primary darken-1">
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small" v-if="date"
                >Atualizado em {{ date }}</span
              >
              <span style="color: lightgrey; font-size: small" v-else
                >Atualizado em ##/##/####</span
              >
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-chart-timeline-variant
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text"
            >Temperatura</v-card-subtitle
          >
          <v-card-text>
            <v-row v-if="!values">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer />
              <v-col cols="9">
                <span style="color: orange"
                  >Os dados de temperatura estão indisponíveis no momento.</span
                >
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <v-icon>mdi-arrow-down</v-icon>
                  {{ Math.trunc(values.tempMin) }} °C
                </strong>
              </v-col>
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <v-icon>mdi-arrow-up</v-icon>
                  {{ Math.trunc(values.tempMax) }} °C
                </strong>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import WaterAvailabilityChart from './WaterAvailabilityChart';
import WaterQualityChart from './WaterQualityChart';
export default {
  name: 'MonitoringDailyForecastResponsive',
  components: {WaterAvailabilityChart, WaterQualityChart},
  props: ['values', 'flow', 'quality', 'availability', 'date'],
  data() {
    return {
      waterAvailability: [
        {text: 'Seca', color: '#FC424A'},
        {text: 'Estiagem', color: '#FFAB00'},
        {text: 'Normal', color: '#0090E7'},
        {text: 'Cheia', color: '#00D25B'},
        {text: 'Inundação', color: '#8F5FE8'},
      ],
      waterQuality: [
        {text: 'Ruim', color: '#3BD79A'},
        {text: 'Regular', color: '#F39946'},
        {text: 'Boa', color: '#659CD5'},
      ],
    };
  },
  computed: {
    waterQualityBorderColor() {
      if (this.quality.values) {
        const waterQualityData = this.quality.values.find(
          (obj) => obj.tipo === 'total',
        );
        if (waterQualityData.valor <= 44) {
          return '#C00000';
        }
        if (waterQualityData.valor > 44 && waterQualityData.valor <= 64) {
          return '#C75911';
        }
        if (waterQualityData.valor > 64 && waterQualityData.valor <= 79) {
          return '#FFD966';
        }
        if (waterQualityData.valor > 79 && waterQualityData.valor <= 94) {
          return '#FFAB00';
        }
        if (waterQualityData.valor > 94) {
          return '#8EA9DB';
        }
      }
      return 'white';
    },
  },
};
</script>

<style scoped>
.seventy.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.forty.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.ten.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.cheia.v-card.v-sheet.theme--dark {
  border-left: 7px solid #8f5fe8 !important;
}
.rioalto.v-card.v-sheet.theme--dark {
  border-left: 7px solid #00d25b !important;
}
.normal.v-card.v-sheet.theme--dark {
  border-left: 7px solid #0090e7 !important;
}
.riobaixo.v-card.v-sheet.theme--dark {
  border-left: 7px solid #ffab00 !important;
}
.estiagem.v-card.v-sheet.theme--dark {
  border-left: 7px solid #fc424a !important;
}
.none.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.quality.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.v-card.v-sheet.theme--dark {
  min-height: 300px;
  min-width: 150px;
  /*max-height: 350px;*/
  max-width: 350px;
}
</style>
